module.exports = __webpack_public_path__ + "img/session_complete.d89747d6.png";